// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__ojiXG","header":"Messages_header__11bpq"};